import { useState } from "react";

import Modal from "ui-components/Modal";

import UploadFiles from "modules/data-files/elements/upload-files";

const NoExistingData = ({ message }: { message?: React.ReactNode }) => {
  const [showFileUpload, setShowFileUpload] = useState(false);
  return (
    <div>
      <p className="text-center">
        {message ||
          "You dont seem to have any data uploaded to the platform!!!"}{" "}
        <a
          className="underline text-primary-main cursor-pointer"
          onClick={() => setShowFileUpload(true)}
        >
          Click here to upload.
        </a>
      </p>
      <Modal
        show={showFileUpload}
        id="upload-files"
        handleClose={() => setShowFileUpload(false)}
      >
        <div className="m-2 p-2">
          <UploadFiles onComplete={() => setShowFileUpload(false)} />
        </div>
      </Modal>
    </div>
  );
};

export default NoExistingData;
